import { combineReducers } from 'redux';
import topnav from '@lesofi/phoenix-sdk-js/lib/admin/redux/topnav/reducer'
import { reducer as form } from 'redux-form'
import auth from '@lesofi/phoenix-sdk-js/lib/admin/redux/auth/reducer'
import td from '@lesofi/phoenix-sdk-js/lib/admin/redux/taskDists/reducer';
import generic from '@lesofi/phoenix-sdk-js/lib/admin/redux/generic/reducer'

export default combineReducers({auth,topnav,form,td,generic});


// WEBPACK FOOTER //
// ./src/redux/reducer.js